import styled from "@emotion/styled"
import { css } from "@emotion/react"
import SearchBar from "../Radiate/SearchBar/SearchBar"
import NewBoxButton from "../Radiate/NewBoxButton/NewBoxButton"

export const CallHistoryListContainer = styled.div`
  position: absolute;
  left: 0;
  width: 416px;
  min-width: 416px;
  height: 100%;
  transform: ${props => (!props.show ? "translateX(-100%)" : "translateX(0px)")};
  transition: opacity 0.4s ease, transform 0.4s ease-in-out;
  z-index: 99;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  ${(props) => props.mobile && css`
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 100%;
    transition: transform 0.4s ease-in-out;
    transform: ${props.show ? "translateY(0)" : "translateY(100%)"};
    min-width: auto;
  `}
`

export const CallHistoryListTopContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 12px;
  border-bottom: 1px solid ${(props) => props.theme.gray1};
  background: white;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  flex-shrink: 0;
  z-index: 10;

  .close-button {
    >.icon {
      font-size: 1rem;
    }
  }
`

export const MemberSearchBar = styled(SearchBar)`
  margin-left: 8px;
`

export const DesktopUISearch = styled.div`
  display: block;
  @media (max-width:989px) {
    display: none;
  }
`

export const CallHistoryCard = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  background: white;
  border-radius: 10px;
  border: 1px solid white;
  padding: 10px 6px;
  box-shadow: none;
  transition: all 0.2s ease;
  cursor: pointer;

  &:active {
    transform: scale(0.99);
  }
`

export const CallHistoryRow = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`

export const LoadingContainer = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
  background: ${(props) => props.theme.palerBackground};
`

export const LoadMoreButton = styled(NewBoxButton)`
  width: 100%;
`

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
  padding: 4px 4px;
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  background: #f0f1f7;

  /* Custom scrollbar */
  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: #d1d5db;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #9ca3af;
    widt: 6px;
  }
`

export const RowContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 2px 6px;

`

export const FilterButton = styled.button`
  border: none;
  color: ${(props) => props.active ? "white" : props.theme.gray4};
  height: 36px;
  width: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  cursor: pointer;
  border-radius: 6px;
  background: ${(props) => props.active ? "#405ce6" : props.theme.gray1};
  transition: color 0.4s ease;

  svg {
    width: 18px;
    height: 18px;
  }

  &:hover {
    color: ${(props) => props.active ? props.theme.gray1 : "#405ce6"};
    background: ${(props) => props.active ? "#405ce6" :props.theme.gray1}
  }
`


export const UserInfo = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;
`;

export const UserImage = styled.img`
  min-width: 40px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
  position: relative;
`;

export const UserImageFallback = styled.div`
  min-width: 40px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(props) => props.theme.gray3};
  position: relative;
  flex-shrink: 0;
  
  svg {
    width: 48px;
    height: 48px;
  }
`

export const AvatarBadge = styled.div`
  position: absolute;
  bottom: -2px;
  right: -2px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #25D366;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid white;
  
  svg {
    width: 12px;
    height: 12px;
  }
`;

export const Title = styled.div`
  font-weight: 600;
  font-size: 15px;
  color: #111827;
`;

export const DateText = styled.div`
  font-size: 12px;
  color: ${(props) => props.theme.gray5};
  font-weight: 500;
  white-space: nowrap;
`;

export const ChannelContent = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  margin-top: 6px;
  color: #555;
`;

export const UnreadIndicator = styled.div`
  width: 12px;
  height: 12px;
  background: #c62828;
  border-radius: 50%;
  margin-left: auto;
`;

export const Message = styled.div`
  display: inline-flex;
  align-items: center;
  margin-top: 4px;
  color: #777;
  font-size: 14px;

  svg {
    height: 14px;
    width: 14px;
    color: gray;
  }
`;

export const CallStatusRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 6px;
`;

export const CallIconContainer = styled.div`
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  color: ${(props) => props.color || "#8696a0"};
  
  svg {
    width: 14px;
    height: 14px;
  }
`;

export const CallDirectionArrow = styled.span`
  position: absolute;
  bottom: -4px;
  right: -4px;
  font-size: 10px;
  font-weight: bold;
  color: ${(props) => props.direction === "incoming" ? "#25D366" : "#8696a0"};
  transform: ${(props) => props.direction === "incoming" ? "rotate(225deg)" : "rotate(45deg)"};
`;

export const CallStatusText = styled.span`
  font-size: 13px;
  color: ${(props) => props.color || "#8696a0"};
  font-weight: 400;
`;

export const ActionButtons = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const RightSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  ${'' /* justify-content: space-between; */}
  margin-left: auto;
  gap: 10px;
  height: 100%;
`;

export const ActionButton = styled.button`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: none;
  background: transparent;
  color: #25D366;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;

  svg {
    width: 18px;
    height: 18px;
    fill: currentColor;
  }

  &:hover {
    background: #f0fdf4;
    transform: scale(1.1);
  }

  &:active {
    transform: scale(0.95);
  }

  &:last-child {
    color: #6b7280;
    
    &:hover {
      background: #f3f4f6;
    }
  }
`;

export const EmptyState = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${(props) => props.theme.gray7};
  font-size: ${(props) => props.theme.textM};
  padding: 24px;
`;
export const ContactName = styled.div`
  font-weight: 700;
  font-size: 15px;
  color: #111827;
  margin-bottom: 2px;
`;

export const IntegrationBadge = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
  position: relative;
  margin-top: 2px;
  
  span {
    font-size: 14px;
    color: ${(props) => props.theme.gray5};
    font-weight: 400;
  }
  
  svg {
    flex-shrink: 0;
  }
`;

export const CallStatusMessage = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
  overflow: hidden;
  flex: 1;

  svg {
    margin-top: 2px;
  }
  
  span {
    font-size: 14px;
    color: ${(props) => props.theme.gray5};
    font-weight: 400;
    line-height: 1.4;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const CallStatusIcon = styled.div`
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  
  svg {
    width: 14px;
    height: 14px;
    fill: ${props => props.iconColor || "#6b7280"};
  }
`;

export const MissedCallIndicator = styled.div`
  width: 14px;
  height: 14px;
  background: #cc0200;
  border-radius: 50%;
  flex-shrink: 0;
`;
